import { apiRequest } from './http';
import { createAdminApi } from './domains/admin';
import { createAuthApi } from './domains/auth';
import { createBackupApi } from './domains/backup';
import { createAssistantApi } from './domains/assistant';
import { createKnowledgeBaseApi } from './domains/knowledgeBase';
import { createCockpitApi } from './domains/cockpit';
import { createBriefingApi } from './domains/briefing';
import { createAddressSuggestionsApi } from './domains/addressSuggestions';
import { createStatsApi } from './domains/stats';
import { createCustomerRequestsApi } from './domains/customerRequests';
import { createCustomerMasterDataApi } from './domains/customerMasterData';
import { createCustomerCareApi } from './domains/customerCare';
import { createCustomerDeadlinesApi } from './domains/customerDeadlines';
import { createCustomerReportsApi } from './domains/customerReports';
import { createOnsiteOpportunitiesApi } from './domains/onsiteOpportunities';
import { createCwLookupsApi } from './domains/cwLookups';
import { createDispatchApi } from './domains/dispatch';
import { createDiagnoseApi } from './domains/diagnose';
import { createInfrastructureApi } from './domains/infrastructure';
import { createInventoryReadApi } from './domains/inventoryRead';
import { createLagerApi } from './domains/lager';
import { createInventorySessionsApi } from './domains/inventorySessions';
import { createGoodsReceiptsApi } from './domains/goodsReceipts';
import { createPurchaseOrdersApi } from './domains/purchaseOrders';
import { createSuppliersApi } from './domains/suppliers';
import { createKanbanApi } from './domains/kanban';
import { createOsrmApi } from './domains/osrm';
import { createSubmissionsApi } from './domains/submissions';
import { createSyncApi } from './domains/sync';
import { createTicketsApi } from './domains/tickets';
import { createTripsApi } from './domains/trips';
import { createWeclappApi } from './domains/weclapp';
import { createTechnicianHubApi } from './domains/technicianHub';
import { createTechnicianRequestsApi } from './domains/technicianRequests';
import { createExternalToolsApi } from './domains/externalTools';
import { createSettingsApi } from './domains/settings';
import { createPortalTimeBookingApi } from './domains/portalTimeBooking';
import { createTimeProposalsApi } from './domains/timeProposals';
import { createAttendanceApi } from './domains/attendance';
import { createDnsZonesApi } from './domains/dnsZones';
import { createAutodnsDomainsApi } from './domains/autodnsDomains';
import { createTicketHandoverApi } from './domains/ticketHandover';
import { createContactSuggestionsApi } from './domains/contactSuggestions';
import { createMaintenanceApi } from './domains/maintenance';
import { createPushApi } from './domains/push';
import { createProcurementApi } from './domains/procurement';
import { createContactDirectoryApi } from './domains/contactDirectory';
import { createInboundTicketCallsApi } from './domains/inboundTicketCalls';
import { createUnknownCallersApi } from './domains/unknownCallers';
import { createCallbacksApi } from './domains/callbacks';
import { createCallsApi } from './domains/calls';
import { createChatsApi } from './domains/chats';
import { createWhatsappAdminApi } from './domains/whatsappAdmin';
import { createTicketSenderTriageApi } from './domains/ticketSenderTriage';
import { createEmailLogsApi } from './domains/emailLogs';
import { createTodosApi } from './domains/todos';
import { createTicketTrashApi } from './domains/ticketTrash';
import { createTicketDuplicatesApi } from './domains/ticketDuplicates';
import { createNotificationsApi } from './domains/notifications';
import { createPortalAccessRequestsApi } from './domains/portalAccessRequests';
import { createKianWorklistApi } from './domains/kianWorklist';
import { createKianInjectionsApi } from './domains/kianInjections';
import { createKianActionsApi } from './domains/kianActions';
import { createKianVoiceApi } from './domains/kianVoice';
import { createOnCallApi } from './domains/onCall';
import { createJibbleApi } from './domains/jibble';
import { createOdometerApi } from './domains/odometer';
import { createBillingJournalApi } from './domains/billingJournal';
import { createControlHubOrdersApi } from './domains/controlhubOrders';
import { createMailIntakeApi } from './domains/mailIntake';
import { createProjectsApi } from './domains/projects';
import { createCalendarApi } from './domains/calendar';

const authApi = createAuthApi(apiRequest);

export const api = {
  ...createSubmissionsApi(apiRequest),
  ...createAdminApi(apiRequest),
  ...createCwLookupsApi(apiRequest),
  ...createTicketsApi(apiRequest),
  ...createOsrmApi(apiRequest),
  ...createTripsApi(apiRequest),
  ...createKanbanApi(apiRequest),
  ...createDispatchApi(apiRequest),
  ...createCockpitApi(apiRequest),
  ...createBriefingApi(apiRequest),
  ...createAddressSuggestionsApi(apiRequest),
  ...createStatsApi(apiRequest),
  ...createCustomerRequestsApi(apiRequest),
  ...createCustomerMasterDataApi(apiRequest),
  ...createCustomerCareApi(apiRequest),
  ...createCustomerDeadlinesApi(apiRequest),
  ...createCustomerReportsApi(apiRequest),
  ...createOnsiteOpportunitiesApi(apiRequest),
  ...createDiagnoseApi(apiRequest),
  ...createInventoryReadApi(apiRequest),
  ...createLagerApi(apiRequest),
  ...createInventorySessionsApi(apiRequest),
  ...createGoodsReceiptsApi(apiRequest),
  ...createPurchaseOrdersApi(apiRequest),
  ...createSuppliersApi(apiRequest),
  ...createInfrastructureApi(apiRequest),
  ...createWeclappApi(apiRequest),
  ...createSyncApi(apiRequest),
  ...createTechnicianHubApi(apiRequest),
  ...createTechnicianRequestsApi(apiRequest),
  ...createPortalAccessRequestsApi(apiRequest),
  ...createKianWorklistApi(apiRequest),
  ...createKianInjectionsApi(apiRequest),
  ...createKianActionsApi(apiRequest),
  ...createKianVoiceApi(apiRequest),
  ...createOnCallApi(apiRequest),
  ...createJibbleApi(apiRequest),
  ...createOdometerApi(apiRequest),
  ...createBillingJournalApi(apiRequest),
  ...createControlHubOrdersApi(apiRequest),
  ...createMailIntakeApi(apiRequest),
  ...createExternalToolsApi(apiRequest),
  ...createSettingsApi(apiRequest),
  ...createPortalTimeBookingApi(apiRequest),
  ...createTimeProposalsApi(apiRequest),
  ...createAttendanceApi(apiRequest),
  ...createDnsZonesApi(apiRequest),
  ...createAutodnsDomainsApi(apiRequest),
  ...createBackupApi(apiRequest),
  ...createAssistantApi(apiRequest),
  ...createKnowledgeBaseApi(apiRequest),
  ...createTicketHandoverApi(apiRequest),
  ...createContactSuggestionsApi(apiRequest),
  ...createMaintenanceApi(apiRequest),
  ...createPushApi(apiRequest),
  ...createProcurementApi(apiRequest),
  ...createContactDirectoryApi(apiRequest),
  ...createInboundTicketCallsApi(apiRequest),
  ...createUnknownCallersApi(apiRequest),
  ...createCallbacksApi(apiRequest),
  ...createCallsApi(apiRequest),
  ...createChatsApi(apiRequest),
  ...createWhatsappAdminApi(apiRequest),
  ...createTicketSenderTriageApi(apiRequest),
  ...createEmailLogsApi(apiRequest),
  ...createTodosApi(apiRequest),
  ...createTicketTrashApi(apiRequest),
  ...createTicketDuplicatesApi(apiRequest),
  ...createNotificationsApi(apiRequest),
  ...createProjectsApi(apiRequest),
  ...createCalendarApi(apiRequest),
  ...authApi,
};

export const getLoginOptions = authApi.getLoginOptions.bind(authApi);
export const requestMagicLink = authApi.requestMagicLink.bind(authApi);
export const startMicrosoftSso = authApi.startMicrosoftSso.bind(authApi);
export const pollMicrosoftSso = authApi.pollMicrosoftSso.bind(authApi);

export type ApiClient = typeof api;
export type {
  LoginOptionsResult,
  MagicLinkRequestResult,
  MicrosoftSsoStartResult,
  MicrosoftSsoPollResult,
} from './domains/auth';
